import { useAnalyticsConsent } from "../contexts/AnalyticsConsentContext";

function AnalyticsSettingsLink({ className = "" }) {
  const { openAnalyticsSettings } = useAnalyticsConsent();

  return (
    <button
      type="button"
      onClick={openAnalyticsSettings}
      className={`no-underline transition hover:text-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 ${className}`}
    >
      Analytics settings
    </button>
  );
}

export default AnalyticsSettingsLink;
